module.exports = __webpack_public_path__ + "img/1688694188915-IMG-20230707-WA0009.jpg.62f1cee1.webp";